/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AccommodationListingsPositionSimulation_PositionOnListing = {
    listingType?: AccommodationListingsPositionSimulation_PositionOnListing.listingType;
    listingId?: string;
    position?: number | null;
    listingTotalCount?: number | null;
};
export namespace AccommodationListingsPositionSimulation_PositionOnListing {
    export enum listingType {
        CITY = 'city',
        REGION = 'region',
    }
}
